const options = {
  INTERNATIONAL_ARRIVALS: "INTERNATIONAL_ARRIVALS",
  INTERNATIONAL_DEPARTURES: "INTERNATIONAL_DEPARTURES",
  DOMESTIC_ARRIVALS: "DOMESTIC_ARRIVALS",
  DOMESTIC_DEPARTURES: "DOMESTIC_DEPARTURES",
};

export default options;
